import React from 'react'

import { BadgeDotRender } from '@app/components/renderers'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { CompetitorsPricesDataSource } from '../types'

const getOptions = (): Array<Column<CompetitorsPricesDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(key => !['matchingStatus'].includes(key)) as Array<
  keyof CompetitorsPricesDataSource
  >

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }
  })
}

export const getColumns = (): Array<Column<CompetitorsPricesDataSource>> => {
  return getColumnsFromMap<CompetitorsPricesDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'matchingStatus',
        render: (_, { matchingStatus }) => <BadgeDotRender status={ matchingStatus } />
      }
    ]
  })
}
